import { render, staticRenderFns } from "./AllesgoKategori.vue?vue&type=template&id=2cb7bcce&scoped=true"
import script from "./AllesgoKategori.vue?vue&type=script&lang=js"
export * from "./AllesgoKategori.vue?vue&type=script&lang=js"
import style0 from "./AllesgoKategori.vue?vue&type=style&index=0&id=2cb7bcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7bcce",
  null
  
)

export default component.exports